import React from 'react'

export default ({
  className = '',
  fill = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 38.594 42.607"><g transform="translate(-805.224 -653.946)"><path d="M11.826-9.283,2.542,0,1.791.786l.751.785,9.284,9.284,1.57-1.57L5.989,1.878H27.9V-.306H5.989L13.4-7.713Z" transform="translate(815.915 663.23)" fill={fill}/><path className="a" d="M11.826-9.283,2.542,0,1.791.786l.751.785,9.284,9.284,1.57-1.57L5.989,1.878H27.9V-.306H5.989L13.4-7.713Z" transform="translate(803.432 685.699)" fill={fill}/></g></svg>
  )
